import React from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Button,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { Menu as MenuIcon, Settings, Lock } from "@mui/icons-material";
import Swal from "sweetalert2";
import useUsuario from "../../../hooks/api/useUsuario";
import { getUserId, getUserName } from "../../../utils/userSession";
import { corGeral } from "../../../Styles/cores";
import { toastNotify, notifyError } from "../../../services/alertApi";

interface IHeaderProps {
  handleDrawerToggle: () => void;
}

const Header: React.FC<IHeaderProps> = ({ handleDrawerToggle }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const { alterarSenha } = useUsuario();
  const userName = getUserName();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (openMenu) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const handleAlterarSenha = async () => {
    handleClose();
    
    const userId = getUserId();
    
    if (!userId) {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível identificar o usuário. Por favor, faça login novamente.",
        confirmButtonColor: corGeral.navyBlue,
      });
      return;
    }

    const { value: formValues } = await Swal.fire({
      title: "Alterar Senha",
      html: `
        <div style="text-align: left;">
          <p style="margin: 0 0 20px 0; padding: 0; color: #666; font-size: 14px; line-height: 1.5;">
            Digite sua nova senha. Certifique-se de que ela tenha no mínimo 6 caracteres.
          </p>
          <div style="position: relative; margin-bottom: 15px;">
            <input 
              id="swal-password1" 
              type="password" 
              placeholder="Nova Senha"
              style="width: 100%; padding: 10px 40px 10px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 14px; box-sizing: border-box; outline: none;"
              autocomplete="new-password"
              tabindex="1"
            />
            <button 
              type="button"
              id="swal-toggle1"
              tabindex="-1"
              style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); background: transparent; border: none; cursor: pointer; padding: 8px; color: #666; display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; z-index: 10;"
              aria-label="Mostrar senha"
            >
              <svg id="swal-icon1" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </button>
          </div>
          <div style="position: relative;">
            <input 
              id="swal-password2" 
              type="password" 
              placeholder="Confirmar Nova Senha"
              style="width: 100%; padding: 10px 40px 10px 10px; border: 1px solid #ddd; border-radius: 4px; font-size: 14px; box-sizing: border-box; outline: none;"
              autocomplete="new-password"
              tabindex="2"
            />
            <button 
              type="button"
              id="swal-toggle2"
              tabindex="-1"
              style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); background: transparent; border: none; cursor: pointer; padding: 8px; color: #666; display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; z-index: 10;"
              aria-label="Mostrar senha"
            >
              <svg id="swal-icon2" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            </button>
          </div>
        </div>
        <style>
          .swal2-popup {
            overflow: visible !important;
          }
          .swal2-html-container {
            overflow: visible !important;
            max-height: none !important;
          }
          #swal-password1:focus, #swal-password2:focus {
            border-color: ${corGeral.navyBlue} !important;
            box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1) !important;
          }
          #swal-toggle1:hover, #swal-toggle2:hover {
            color: ${corGeral.navyBlue} !important;
            background-color: rgba(0, 0, 0, 0.05) !important;
            border-radius: 50% !important;
          }
          #swal-toggle1:active, #swal-toggle2:active {
            background-color: rgba(0, 0, 0, 0.1) !important;
          }
        </style>
      `,
      width: "500px",
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Alterar Senha",
      cancelButtonText: "Cancelar",
      confirmButtonColor: corGeral.navyBlue,
      cancelButtonColor: "#6c757d",
      allowOutsideClick: false,
      allowEscapeKey: true,
      stopKeydownPropagation: false,
      didOpen: () => {
        const popup = document.querySelector(".swal2-popup");
        const container = document.querySelector(".swal2-html-container");
        if (popup) {
          (popup as HTMLElement).style.overflow = "visible";
        }
        if (container) {
          (container as HTMLElement).style.overflow = "visible";
          (container as HTMLElement).style.maxHeight = "none";
        }
        
        setTimeout(() => {
          const input1 = document.getElementById("swal-password1") as HTMLInputElement;
          const input2 = document.getElementById("swal-password2") as HTMLInputElement;
          
          if (input1) {
            input1.readOnly = false;
            input1.disabled = false;
            
            setTimeout(() => {
              input1.focus();
            }, 100);
            
            input1.addEventListener("keydown", (e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                if (input2) {
                  input2.focus();
                }
              }
            });
          }
          
          if (input2) {
            input2.readOnly = false;
            input2.disabled = false;
          }
          
          const togglePassword = (inputId: string, toggleId: string, iconId: string) => {
            const input = document.getElementById(inputId) as HTMLInputElement;
            const toggle = document.getElementById(toggleId) as HTMLButtonElement;
            const icon = document.getElementById(iconId) as HTMLElement;
            
            if (input && toggle && icon) {
              toggle.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                if (input.type === "password") {
                  input.type = "text";
                  if (icon) {
                    icon.innerHTML = `
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                      <line x1="1" y1="1" x2="23" y2="23"></line>
                    `;
                  }
                  toggle.setAttribute("aria-label", "Ocultar senha");
                } else {
                  input.type = "password";
                  if (icon) {
                    icon.innerHTML = `
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    `;
                  }
                  toggle.setAttribute("aria-label", "Mostrar senha");
                }
              });
            }
          };
          
          togglePassword("swal-password1", "swal-toggle1", "swal-icon1");
          togglePassword("swal-password2", "swal-toggle2", "swal-icon2");
        }, 100);
      },
      preConfirm: async () => {
        const input1 = document.getElementById("swal-password1") as HTMLInputElement;
        const input2 = document.getElementById("swal-password2") as HTMLInputElement;
        
        const newPassword = input1?.value || "";
        const confirmPassword = input2?.value || "";

        if (!newPassword.trim()) {
          Swal.showValidationMessage("Nova senha é obrigatória");
          return false;
        }

        if (newPassword.length < 6) {
          Swal.showValidationMessage("Senha deve ter no mínimo 6 caracteres");
          return false;
        }

        if (!confirmPassword.trim()) {
          Swal.showValidationMessage("Confirmação de senha é obrigatória");
          return false;
        }

        if (newPassword !== confirmPassword) {
          Swal.showValidationMessage("As senhas não coincidem");
          return false;
        }

        const confirmButton = Swal.getConfirmButton();
        const cancelButton = Swal.getCancelButton();
        
        if (confirmButton) {
          confirmButton.disabled = true;
          confirmButton.style.opacity = "0.7";
          confirmButton.innerHTML = '<span class="swal2-loader" style="margin-right: 8px;"></span> Alterando...';
        }
        
        if (cancelButton) {
          cancelButton.disabled = true;
          cancelButton.style.opacity = "0.5";
        }

        try {
          await alterarSenha(userId, newPassword);

          Swal.close();

          toastNotify({
            status: "success",
            title: "Sucesso",
            message: "Sua senha foi alterada com sucesso.",
          });

          return true;
        } catch (error: any) {
          const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            "Erro ao alterar senha. Por favor, tente novamente.";
          
          if (confirmButton) {
            confirmButton.disabled = false;
            confirmButton.style.opacity = "1";
            confirmButton.innerHTML = "Alterar Senha";
          }
          if (cancelButton) {
            cancelButton.disabled = false;
            cancelButton.style.opacity = "1";
          }

          Swal.close();
          notifyError(errorMessage);
          
          return false;
        }
      },
    });
  };

  return (
    <Box 
      sx={{ display: "flex", position: "fixed", top: 0, zIndex: 2100 }}
      onClick={(e) => {
        const target = e.target as HTMLElement;
        if (openMenu && 
            !target.closest('button[aria-haspopup]') && 
            !target.closest('[role="menu"]') &&
            !target.closest('[role="menuitem"]')) {
          setAnchorEl(null);
        }
      }}
    >
      <AppBar
        position="fixed"
        sx={{
          width: "100%",
          height: "70px",
          color: `white`,
          backgroundColor: `white`,
          boxShadow: "none",
          zIndex: 2100,
          overflow: "visible",
        }}
      >
        <Toolbar 
          sx={{ 
            display: "flex", 
            justifyContent: "space-between",
            overflow: "visible",
            position: "relative",
          }}
        >
          <Button onClick={handleDrawerToggle} sx={{ zIndex: 999 }}>
            <MenuIcon />
          </Button>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {userName && (
              <Typography
                variant="body1"
                sx={{
                  color: (theme) => theme.palette.text.primary,
                  fontWeight: 500,
                  mr: 1,
                }}
              >
                {userName}
              </Typography>
            )}
            <IconButton
              onClick={handleClick}
              sx={{
                color: (theme) => theme.palette.text.primary,
              }}
            >
              <Settings />
            </IconButton>
          </Box>
          <Menu
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleClose}
            sx={{
              mt: 2.5,
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            PaperProps={{
              sx: {
                zIndex: 2200,
                mt: 0.5,
              },
            }}
            MenuListProps={{
              sx: {
                py: 0.5,
              },
            }}
          >
            <MenuItem onClick={handleAlterarSenha}>
              <ListItemIcon>
                <Lock fontSize="small" />
              </ListItemIcon>
              <ListItemText>Alterar Senha</ListItemText>
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
